import React from 'react'
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/scrollbar/scrollbar.scss';

// Workaround: Swiper Navigation and Scrollbar-scss are not imported in the build...
import './navigation.scss'
import './scrollbar.scss'

import { Box } from '../box/main.component.tsx';
import './styles.scss'

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

const Kontext = props => {
  return (
  <div className='kontext'>
    {props.children}
    <div className='line' />
  </div>
  )
}

export function Letters(props) {

  return (
    <Box
    >
      <div className='letters'>
        <Swiper
          autoHeight = {true}
          spaceBetween={0}
          slidesPerView={1}
          navigation
          scrollbar={{ draggable: true }}
          loop = {false}
        >
          <SwiperSlide>
            <div className='slide'>
              <h1>Die Briefe der Lea Stemmer</h1>
              <p>
                Sechs Briefe und zwei Postkarten von Lea Stemmer fand Patrick Gutenberg im Nachlass seines Vaters. Sie waren mit einer Ausnahme an seine Grossmutter Lea (Leitschi), Lea Stemmers Nichte, gerichtet. Es folgen eine Zusammenfassung und einige Passagen im Originalton. Abgesetzt davon zeigen wir in kurzen Einschüben, wie die Diskriminierung und Verfolgung der jüdischen Bevölkerung durch das Nationalsozialistische Regime fortschreitet.
              </p>
              <p>
              </p>
              <img src={require('../../images/briefe.jpg')} alt='Die Briefe der Stemmers'/>
            </div>
          </SwiperSlide>
          
          <SwiperSlide>
            <div className='slide'>
              <Kontext>
                Am 1. August 1936 eröffnete Hitler die Olympischen Sommerspiele in Berlin. Um international gut dazustehen, werden die durch die Nürnberger Gesetze bereits am 15. September 1935 eingeführten Schikanen gegenüber der jüdischen Bevölkerung etwas zurückgefahren.
              </Kontext>

              <h4>Hamburg, 7. November 1936</h4>
              <p>
                Drei Briefbögen, hinten und vorne dicht beschrieben. Adressiert an L. Gutenberg, Tricotwarenfabrik an der Forchstrasse 28.
              </p>
              <p>
                Lea Stemmer reagiert auf einen Brief ihrer Nichte aus Zürich, in der sie berichtet, dass es dem Geschäft recht gehe und alle gesund seien. Dabei erwähnt sie den damals 3-jährigen Pezi-Bueb, Patricks Vater: «Wie gerne möchte ich den goldigen Pezi-Bueb sehen und ans Herz drücken.»
              </p>

              {/* <img src={require('./images/pezibueb.png')} className='small' alt='Briefauszug' /> */}

              <p>Schnell gerät sie aber darüber ins Klagen, dass ihre Verwandten ihr nicht häufiger schreiben: «Es wurde versprochen, öfters zu schreiben, aber leider ist es nicht der Fall.»</p>
              <p>Bis hierhin liest sich das wie ein ganz normaler Brief einer etwas nörglerischen Verwandten. Dann schreibt sie über die angeschlagene Gesundheit ihres Mannes Moritz, der ein Lungenleiden hat und zur Kur musste. Es scheint sich um eine enge und gute Beziehung zu handeln. Über sich schreibt sie: «Ich bemühe mich sehr, irgend etwas anzufangen, aber es ist schwer.»</p>

              <p>Was ist schwer? Die Krankheit ihres Mannes? Die Lebensumstände, die schon damals zumindest bedrückend sein mussten. Schliesslich wechselt sie noch zum Klatsch. Offenbar hat ihre Nichte ihr geschrieben, dass ihr Dienstmädchen sie mitten im Umzug im Stich gelassen habe. Sie schreibt: «Dass Dich Dein Mädel gerade beim Umzug im Stiche gelassen hat, war ihr ähnlich, so sah sie nämlich aus.»</p>


            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className='slide'>
              <Kontext>
                1937: Hamburger Juden leiden seit Jahren unter offener Gewalt, die aber oft durch Gesetze oder Erlasse legitimiert waren. Auch sind bereits viele jüdische Geschäfte «arisiert» worden. Jüdische Emigrantinnen und Emigranten werden finanziell erbarmungslos übervorteilt oder gar enteignet.
              </Kontext>

              <h4>Hamburg, 15. Februar 1937</h4>
              <p>Postkarte, beidseitig dicht beschrieben. In der Adresse spezifiziert sie das Geschäft an der Forchstrasse 28 in Zürich mit «Tricotkleider nach Mass». Ein Satz ist eingeschwärzt. Unklar, von wem.</p>

              <p>Dieses Mal unterschreibt sie förmlich als Tante Lea ‑ vielleicht, weil eine Postkarte einen öffentlicheren Charakter hat, da sie ja nicht in einem Couvert verschickt wird. Wieder hebt sie damit an, wie sie sich freut, dass das Geschäft gut geht und alle gesund sind. Auch dem Onkel, also ihrem Mann Moritz, gehe es «gottlob» besser. Sie hofft, dass er bald aus der «Heilanstalt» zurückkehren und wieder arbeiten kann. Dann schreibt sie: «Aber ich weiss noch nicht, was wir beginnen werden, denn für uns ist es unmöglich.»</p>

              <p>Der Nebensatz ist geschwärzt. Dann fährt sie fort: «Vielleicht könnt ihr uns beraten, was wir machen sollen.» Danach lamentiert sie wieder darüber, dass ihr niemand schreibt.  «Die wollen von der bösen Tante nichts wissen.»</p>
              {/* <img src={require('./images/geschwaerzt.png')} className='small' alt='Briefauszug' /> */}

              <p>Ein bisschen kokett wirkt dies schon. Gleichzeitig scheint Lea Stemmer doch ziemlich resolut. Patrick Gutenberg zitiert den Satz immer wieder mit dem Zusatz: «Das passt schon in diese Familie.»</p>
            </div>            
          </SwiperSlide>

          <SwiperSlide>
            <div className='slide'>
              <h4>Hamburg 16. Oktober 1937</h4>

              <p>Postkarte, beidseitig eng beschrieben, die Grüsse sind am Schluss auf dem Kopf in die letzte freie Ecke gezwängt.</p>
              <p>Nun wird, was vorher angedeutet wurde, explizit. Die Stemmers geraten in existenzielle Nöte. Lea Stemmer arbeitet in der Firma, für die ihr Mann vor Ausbruch seiner Krankheit und nachdem er seinen Eierhandel zwangsweise verkaufen musste tätig war. «Ich arbeite im Lager, aber ich verdiene leider sehr wenig, so dass wir beide nicht davon existieren können, aber ich habe wenigstens ein kleines Einkommen, so dass wir uns kaum über Wasser halten können. Wie ich mich plagen muss, kann ich Dir kaum beschreiben …»</p>

              <p>Es folgt die stereotype Bitte, recht bald zu schreiben und alle zu grüssen.</p>
            </div>            
          </SwiperSlide>  

          <SwiperSlide>
            <div className='slide'>
              <Kontext>
                Frühling 1938: Im ganzen Reichsgebiet, zu dem seit Mitte März auch Österreich gehört, kommt es gegen Juden zu Einschüchterungs- und Terroraktionen der NSDAP und der SA. Skandiert wird: «Juden raus aus der Wirtschaft.»                
              </Kontext>

              <h4>Hamburg 17. Januar 1938</h4>
              <p>Der Brief geht an ihren Schwager in Zürich. Eingelegt wurde ein Briefbogen für ihre Nichte, zu der sie offensichtlich ein besondere Beziehung hatte.</p>
              <p>Erst bedankt sie sich bei ihrem Schwager für den «echten Schweizer Käse, welcher wunderbar schmeckt», und bei ihrer Schwester für die «berühmte Frigor». Die Lebensmittel wurden ihr von ihrem Neffen überbracht, der offenbar in Zürich zu Besuch war. Auch sie war einst zu Besuch in Zürich. Später erfahren wir mehr darüber.</p>
              <p>«Wie gerne möchte ich noch einmal bei Euch sein. Wie ihr wohl gehört habt, bin ich beschäftigt und habe es sehr schwer.» </p>
              <p>Im Brief an die Nichte dankt sie für die «wunderschöne Jacke» ... «Ich habe mich so sehr dazu gefreut, denn die ist so schön u. warm und passt mir grossartig.»</p>
              <p>Mittlerweile ist es klar, dass die Stemmers auf Hilfe ihrer Verwandten im Ausland angewiesen sind. Es ist aber noch keine Rede davon, dass sie auswandern wollen.</p>

            </div>            
          </SwiperSlide> 

          <SwiperSlide>
            <div className='slide'>
              <Kontext>
                Mitte Juni: Die Gestapo nimmt etwa 1500 Juden fest und verschleppt sie in Konzentrationslager. Bei der sogenannten Juni-Aktion werden zudem Tausende als «Asoziale» bezeichnete Menschen deportiert. In Hamburg betrifft diese Aktion 700 Männer, darunter etwa 200 Juden. 
              </Kontext>

              <h4>Hamburg, 1. August 1938</h4>
              <p>Langsam wird in den Briefen Verbitterung spürbar. Leitschi sei die einzige der Zürcher Verwandten, welche an sie denke, schreibt Lea Stemmer an ihre Nichte. «Obwohl ich gleich schreibe, bekomme ich doch keine Antwort.»</p>
              <p>Nun erfahren wir, dass sie im Sommer 1936 in Zürich zu Besuch war. «Es waren schöne 4 Wochen, an welche ich immer zurückdenken muss.»</p>
              <p>Dann erwähnt sie, dass sie sich um ein Visum für die Ausreise in die USA bemühen, bisher aber ohne Erfolg, offenbar da ihr Mann Moritz noch nicht ganz gesund sei. Dafür müsste er noch einmal eine Kur machen, doch fehle ihnen dafür das Geld. «Deshalb wissen wir nicht, was wir beginnen sollen und was werden soll.»</p>

            </div>            
          </SwiperSlide> 

          <SwiperSlide>
            <div className='slide'>
              <Kontext>
                17. August 1938: Es wird verkündet, dass ab Januar 1939 alle Juden den zusätzlichen Vornamen Sara oder Israel annehmen müssen. 26. bis 28.Oktober 1938: Ausweisung von 17’000 polnischen Juden nach Polen. In Hamburg betrifft dies etwa tausend Personen.
              </Kontext>
              <h4>Hamburg, 13. Oktober 1938</h4>
              <p>Zwei Briefbögen. Die Schrift ist deutlich fahriger als noch vor zwei Jahren.</p>

              <p>Lea Stemmer macht einen gehetzten, überforderten Eindruck. «Du schreibst, dass Du mich gerne bei Dir sehen möchtest, so muss ich Dir antworten, dass ich möchte ebenso gerne bei Euch sein. Aber wie kann das möglich sein? Weisst Du vielleicht einen Ausweg?»</p>
              <p>Offenbar ist ihr Mann immer noch leidend, was einer Ausreise im Weg steht. Auf dieses «Ziel» würden sie schon zweieinhalb Jahre warten, schreibt Lea Stemmer ihrer Nichte.</p>
              <p>Dann bemüht sie sich wieder um einen «normalen» Ton:</p>
              <p>«Dass Pezi ein grosser Junge ist, freut mich. Ist er auch brav?»</p>

            </div>            
          </SwiperSlide> 


          <SwiperSlide>
            <div className='slide'>
              <Kontext>
                9./10. November 1938: Reichspogromnacht. Synagogen werden zerstört, oft angezündet, und jüdische Geschäfte systematisch demoliert. 15. November 1938: Jüdische Kinder dürfen keine öffentlichen Schulen mehr besuchen. Deportationen von Juden in Konzentrationslager gehören nun zur Tagesordnung. Noch bedeutet dies nicht der sichere Tod. Etliche kamen nach ein paar Wochen wieder zurück. Allerdings misshandelt und gedemütigt.
              </Kontext>
              <h4>Nachrichten von anderer Seite</h4>
              <p>Anfang 1939 scheint sich für Lea und Moritz Stemmer eine Lösung abzuzeichnen. Dies erfahren wir aus einem Brief, den Nathan und Etel Bernstein am 8. Januar 1939 aus Hamburg ihren Kindern schreiben, die bereits in die USA ausgewandert sind:</p>

              <p>«Stemmers haben neue Pläne und Aussichten. Tante [Leitschi] könnte sofort nach der Schweitz, als rituelle Köchin hingehen. Aber ohne Moritz thut sie es nicht, er erhält kein Visum. Der Konsul der Schweitz, hat ihr gesagt, falls in Zürich die Fremdenpolizei genehmigt dass auch Moritz hinkommen kann sich zu kuriren so wird hier ohne Weiteres Visum erteilt! – Falls es gelingt, und zwar mit Hilfe der Verwandten aus Amerika, durch eine Deponierung einer Summe wahrscheinlich nach dort für die Kur. So wollen die hier den Hausstand auflösen und hinfahren.»</p>

            </div>
          </SwiperSlide> 

          <SwiperSlide>
            <div className='slide'>
              <Kontext>
                April 1939: Den Juden wurde die freie Wohnungswahl verboten, in verschiedenen Städten, so auch in Hamburg, wird eine Ghettoisierung vorangetrieben. Auch werden erste Juden zu Zwangsarbeiten verpflichtet. Noch immer aber realisieren die meisten Hamburger Juden offenbar nicht, was es mit den Deportationen auf sich hat. Sie glauben, dass sie für einen Arbeitseinsatz in den Osten gebracht werden.
              </Kontext>
              <h4>Hamburg, 12. August 1939</h4>
              <p>Kaum mehr höfliches Fragen nach dem Befinden, Lea Stemmer scheint am Ende ihrer Kräfte. Die Aussicht, in die USA auswandern zu können, wird immer zweifelhafter, sie fragt flehentlich an, «was wir unternehmen sollen, dass wir doch nach der Schweiz kommen können». Sie bietet sich als rituelle Köchin an, also als Köchin, die sich an die jüdischen Traditionen (koscher) hält.</p>
              <p>«Glaube mir, meine Teure, dass wir schon ganz mürbe sind, denn was wir anfangen, führt nicht zum Ziel.»</p>

              <p>Es folgen drei kurze Sätze, in denen sie sich nach dem Befinden der Zürcher Verwandten erkundigt, dann:</p>
              <p>«Glaub mir l. Leitschi, dass meine Kräfte am Ende sind, denn ich mache mir furchtbare Sorgen, was aus uns werden soll. Nun glaube ich Dir alles geschrieben zu haben u. hoffe, dass Du unser rettender Engel sein wirst.</p>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className='slide'>
              <Kontext>
                1. September 1939: Beginn des 2. Weltkrieges. Im besetzten Polen werden 400 Ghettos für Juden eingerichtet. Viele von ihnen sterben bereits in den nächsten Monaten an Hunger, Entkräftung und Krankheiten.
              </Kontext>
              <h4>Hamburg 25. September 1939</h4>
              <p>Lea Stemmer schreibt in einem ganz anderen Ton als im Brief, den sie knapp sechs Wochen zuvor an ihre Nichte geschickt hat. Resignation? Sie dankt für ein Päckchen, das sie aus der Schweiz erhalten hat.</p>
              <p>«Ich muss Dir gestehen, dass es uns sehr willkommen war und ich war sehr glücklich überrascht, dass ihr an uns in solcher Beziehung denkt.»</p>

              <p>Unterdessen ist anscheinend auch eine Auswanderung nach Tel Aviv im Gespräch. Aus den USA hat sie offenbar keine Nachricht mehr erhalten.</p>
              <p>«Wir müssen jetzt Geduld haben und hoffen, dass wir recht bald unser Ziel erreichen.»</p>

              <p>
                Zum Schluss:<br />
                «Es grüssen und küssen Dich l Leitschi (...) und recht herzlich und bleiben immer deine dankbaren Onkel Moritz und Tante Lea.»
              </p>

              <p>(Die Orthografie wurde sanft angepasst.)</p>
            </div>
          </SwiperSlide>          

        </Swiper>        
      </div>
    </Box>
  )
}
